import { API_V2 } from "@/config/api";

export const routes = {
  me: `${API_V2}/donors/me`,
  listAccounts: `${API_V2}/donors/me/accounts`,
};
